// extracted by css-extract-rspack-plugin
export default {"content":"content-PblVsY","skipButton":"skipButton-BEzAhu"};